import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import iconmile from '../../../icons/summary/kpi.svg'
import dot from '../../../icons/summary/dot.svg'
import dotColorRed from '../../../icons/summary/dotColorRed.svg'
import dotColorYellow from '../../../icons/summary/dotColorYellow.svg'
import dotColorGreen from '../../../icons/summary/dotColorGreen.svg'
import { Collapse, Progress, Row, Tooltip } from 'antd'
import { InboxOutlined, LockOutlined } from '@ant-design/icons'
import { getCookie } from 'helper/cookie'
import { getalllistKPI_Overview } from 'api/Project/kpifinance'
import { IconMoreKpi } from 'common/SVG/svg.common'
const initalState = {
  data: [],
}
const Kpifinance = (props) => {
  const { project_id, canViewKpi, mainRoleUser } = props
  const token = getCookie('access_token_admin')
  const [data, setData] = useState(initalState.data)
  const KPIContainer = styled.div``
  const [percent, setPercent] = useState(12)

  const { Panel } = Collapse

  const getDataListKPI = async () => {
    await getalllistKPI_Overview({
      project_id: project_id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setData([])

          return true
        }
        if (status === 200) {
          await setData(data)
        } else {
          setData([])

          return true
        }
      })
      .catch((error) => {
        setData([])

        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      getDataListKPI()
    }
  }, [token])

  const playState = () => {
    if (!canViewKpi && mainRoleUser !== '1' && mainRoleUser !== '9') {
      return NoPermission()
    } else if (data.length > 0) {
      return Normalstate2()
    } else {
      return Emptystate()
    }
  }
  const color = {
    percent_0: '#19D895',
    percent_50: '#FF6258',
    percent_75: '#FFAF00',
    percent_100: '#19D895',
  }

  const Normalstate2 = () => {
    return data.map((item, id) => {
      if (item.sub_projectkpi) {
        return (
          <Collapse ghost className='iconCollapse'>
            <Panel header={renderItemMainKpi(item)} key={id}>
              <div style={{ padding: '0px 0px 0px 44px' }}>
                {renderItemChildrenKpi(item.sub_projectkpi)}
              </div>
            </Panel>
          </Collapse>
        )
      } else {
        return renderItemMainKpi(item)
      }
    })
  }

  const renderIconMoreKPI = (goal, sprintflow) => {
    if (goal && sprintflow) {
      return (
        <Tooltip placement='top' title='The value of goals not setup or zero'>
          <div>
            <IconMoreKpi />
          </div>
        </Tooltip>
      )
    } else {
      return <div />
    }
  }

  const renderItemMainKpi = (item) => {
    const dataGold = item.goal === 0 && item.min === 0 && item.max === 0
    const datasprintflowGoal =
      item.sprintflow_goal === 0 && item.sprintflow_min === 0 && item.sprintflow_max === 0

    return (
      <div className='Layoutdisplay' style={{ marginTop: '7px' }}>
        <img className='mediumicon' src={iconmile}></img>
        <div className='areaLayout'>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <p className='cutter-text-line-1'>{item?.name}</p>
            {renderIconMoreKPI(dataGold, datasprintflowGoal)}
          </div>
          <div className='LayoutinScale'>
            <div className='LayLeft'>
              <span style={{ marginLeft: '0px' }} className='small yourprogress-color'>
                Your Progress :
              </span>
              <div className='setcol-inleft'>
                <span
                  className={`percent small ${
                    percent < 75 && percent !== 0
                      ? 'percent-deley'
                      : percent === 100
                      ? 'percent-done'
                      : percent === 0
                      ? 'percent-zero'
                      : 'percent-todo'
                  }`}
                >
                  {item?.done_percent} %
                </span>
                {![22].includes(item?.input_type_id) ? (
                  <span className='small unit' style={{ marginLeft: 5 }}>
                    {`Actual ${item?.actual_goal.toLocaleString()} ${
                      item?.unit_type_name
                    }`}
                  </span>
                ) : (
                  <span className='small unit'>
                    {`Actual ${item?.actual_goal.toLocaleString()} ${
                      item?.unit_type_name
                    }`}
                  </span>
                )}
              </div>
            </div>
            <div className='LayRight'>
              <span className='goal-color small'>Goals :</span>
              {![22].includes(item?.input_type_id) ? (
                <span className='small'>
                  {item?.goal.toLocaleString()} {item?.unit_type_name}
                </span>
              ) : (
                <span className='small'>
                  {item?.min.toLocaleString()} - {item?.max.toLocaleString()}{' '}
                  {item?.unit_type_name}
                </span>
              )}
            </div>
          </div>
          <div className='ProgressStyle'>
            <div className='Target'></div>
            <Progress
              percent={item?.done_percent}
              showInfo={false}
              size='small'
              style={{ width: '100%' }}
              strokeColor={
                item?.done_percent < 75 && item?.done_percent !== 0
                  ? color.percent_50
                  : item?.done_percent >= 100
                  ? color.percent_100
                  : item?.done_percent === 0
                  ? color.percent_0
                  : color.percent_75
              }
            />
          </div>
        </div>
      </div>
    )
  }
  const renderItemChildrenKpi = (item) => {
    return item.map((data) => {
      const dataGold = data.goal === 0 && data.min === 0 && data.max === 0
      const datasprintflowGoal =
        data.sprintflow_goal === 0 &&
        data.sprintflow_min === 0 &&
        data.sprintflow_max === 0

      return (
        <div className='Layoutdisplay-in-children'>
          <img style={{ alignSelf: 'flex-start', marginTop: '5px' }} src={dot}></img>
          <img className='mediumicon' src={iconmile}></img>
          <div className='areaLayout'>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <p className='cutter-text-line-1'>{data?.sprintflow_name}</p>
              {renderIconMoreKPI(dataGold, datasprintflowGoal)}
            </div>
            <div className='LayoutinScale'>
              <div className='LayLeft'>
                <span style={{ marginLeft: '0px' }} className='small yourprogress-color'>
                  Your Progress :
                </span>
                <div className='setcol-inleft'>
                  <span
                    className={`percent small ${
                      percent < 75 && percent !== 0
                        ? 'percent-deley'
                        : percent === 100
                        ? 'percent-done'
                        : percent === 0
                        ? 'percent-zero'
                        : 'percent-todo'
                    }`}
                  >
                    {data?.done_percent} %
                  </span>
                  {![22].includes(data?.input_type_id) ? (
                    <span className='small unit' style={{ marginLeft: 5 }}>
                      {`Actual ${Number(data?.actual_goal).toLocaleString()} ${
                        data?.unit_type_name
                      }`}
                    </span>
                  ) : (
                    <span className='small unit'>
                      {`Actual ${Number(data?.actual_goal).toLocaleString()} ${
                        data?.unit_type_name
                      }`}
                    </span>
                  )}
                </div>
              </div>
              <div className='LayRight'>
                <span className='goal-color small'>Goals :</span>
                {![22].includes(data?.input_type_id) ? (
                  <span className='small'>
                    {Number(data?.sprintflow_goal).toLocaleString()}{' '}
                    {data?.unit_type_name}
                  </span>
                ) : (
                  <span className='small'>
                    {data?.sprintflow_min.toLocaleString()} -{' '}
                    {data?.sprintflow_max.toLocaleString()} {data?.unit_type_name}
                  </span>
                )}
              </div>
            </div>
            <div className='ProgressStyle'>
              <div className='Target'></div>
              <Progress
                percent={data?.done_percent}
                showInfo={false}
                size='small'
                style={{ width: '100%' }}
                strokeColor={
                  data?.done_percent < 75 && data?.done_percent !== 0
                    ? color.percent_50
                    : data?.done_percent >= 100
                    ? color.percent_100
                    : data?.done_percent === 0
                    ? color.percent_0
                    : color.percent_75
                }
              />
            </div>
          </div>
        </div>
      )
    })
  }

  const Emptystate = () => {
    return (
      <div className='emytystate'>
        <InboxOutlined className='inbox' />
        <p>No KPI/Finance</p>
      </div>
    )
  }
  const NoPermission = () => {
    return (
      <div className='emytystate'>
        <LockOutlined className='inbox' />
        <p>No Permission</p>
      </div>
    )
  }

  return (
    <KPIContainer className='kpi-container'>
      <Row>
        <h3>Project KPI/Finance</h3>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <img className='dot_red' src={dotColorRed}></img>
          <h4>{`< 75`}</h4>
          <img className='dot_green' src={dotColorYellow}></img>
          <h4>{`> 75`}</h4>
          <img className='dot_yellow' src={dotColorGreen}></img>
          <h4>{`100`}</h4>
        </div>
      </Row>
      <div className='kpi-overflow-container'>{playState()}</div>
    </KPIContainer>
  )
}

export default Kpifinance
